const optionsShowDateTime = {
   year: 'numeric',
   month: 'long',
   day: 'numeric',
   hour: 'numeric',
   minute: 'numeric',
   // second: 'numeric'
}

const optionsShowDate = {
   year: 'numeric',
   month: 'long',
   day: 'numeric',
   // hour: 'numeric',
   // minute: 'numeric',
   // second: 'numeric'
}

const optionsShowRangeDate = {
   year: 'numeric',
   month: 'numeric',
   day: 'numeric'
}

/**
 * Приводит номер телефона к читабильному виду
 *
 * @param {number} phone The phone number in the format 71234567890
 * @return {string} The phone number in the string '+7 (123) 456-78-90'
 */
export function showPhone (phone) {
   if (!phone) return ''
   return `+${phone.slice(0, 1)}(${phone.slice(1, 4)}) ${phone.slice(4, 7)}-${phone.slice(7, 9)}-${phone.slice(9, 11)}`
}

export function check0_100 (value) {
   return !(value < 0 || value > 100) && !isNaN(value)
}

export function check0_999 (value) {
   return value > 0 && !isNaN(value)
}

export function showName (employee) {
   return `${employee.last_name} ${employee.first_name}`
}

export function showDate (date, showTime=true) {
   const options = showTime ? optionsShowDateTime : optionsShowDate
   return new Date(date * 1000).toLocaleString('ru', options).replace(' г. в', '')
}

export function showRangeDate (range_date) {
   const first = new Date(range_date[0] * 1000).toLocaleString('ru', optionsShowRangeDate).replace(' г. в', '')
   const second = new Date(range_date[1] * 1000).toLocaleString('ru', optionsShowRangeDate).replace(' г. в', '')
   return `${first} - ${second}`
}

export function currentMonth() {
   let today = new Date
   let start_date = new Date
   start_date.setDate(1)
   start_date.setHours(0, 0, 0, 0)
   return [parseInt(start_date / 1000), parseInt(today / 1000)]
}

export function includesObject(obj, list) {
   for (let i = 0; i < list.length; i++) {
      if (list[i].id === obj.id) {
         return true
      }
   }
   return false
}

export function checkObject (object) {
   if (!object) return false
   return Boolean(Object.values(object).length);
}

export function valueOfPhoneInput(number) {
   if (number) {
      switch (number.length) {
         case 0: 
            return ''
         case 1:
            return `+${number[0]}`
         case 2:
            return `+${number[0]} (${number[1]}`
         case 3:
            return `+${number[0]} (${number[1]}${number[2]}`
         case 4:
            return `+${number[0]} (${number[1]}${number[2]}${number[3]}`
         case 5:
            return `+${number[0]} (${number[1]}${number[2]}${number[3]}) ${number[4]}`
         case 6:
            return `+${number[0]} (${number[1]}${number[2]}${number[3]}) ${number[4]}${number[5]}`
         case 7:
            return `+${number[0]} (${number[1]}${number[2]}${number[3]}) ${number[4]}${number[5]}${number[6]}`
         case 8:
            return `+${number[0]} (${number[1]}${number[2]}${number[3]}) ${number[4]}${number[5]}${number[6]}-${number[7]}`
         case 9:
            return `+${number[0]} (${number[1]}${number[2]}${number[3]}) ${number[4]}${number[5]}${number[6]}-${number[7]}${number[8]}`
         case 10:
            return `+${number[0]} (${number[1]}${number[2]}${number[3]}) ${number[4]}${number[5]}${number[6]}-${number[7]}${number[8]}-${number[9]}`
         case 11:
            return `+${number[0]} (${number[1]}${number[2]}${number[3]}) ${number[4]}${number[5]}${number[6]}-${number[7]}${number[8]}-${number[9]}${number[10]}`
      } 
   } else {
      return ''
   }
}

export function valueOfPhoneInput1(number) {
   if (!number) {
      return '';
   }

   const countryCode = number.slice(0, 1);
   const areaCode = number.slice(1, 4);
   const firstPart = number.slice(4, 7);
   const secondPart = number.slice(7, 9);
   const thirdPart = number.slice(9, 11);

   let formattedNumber = `+${countryCode} (${areaCode}) ${firstPart}`;

   if (secondPart) {
      formattedNumber += `-${secondPart}`;
   }

   if (thirdPart) {
      formattedNumber += `-${thirdPart}`;
   }

   return formattedNumber;
}

export const compareDates = (date1, date2) => {
   date1 = new Date(date1 * 1000)
   date2 = new Date(date2 * 1000)
   return date1.getDate() === date2.getDate() &&
       date1.getMonth() === date2.getMonth() &&
       date1.getFullYear() === date2.getFullYear()
}

export const hasIDinHierarchy = (event, listIDs) => {
   const hierarchyIDs = event.composedPath().map(element => element.id);
   return listIDs.some(id => hierarchyIDs.includes(id))
}

export function generateRandomID() {
   let id = '';
   const idLength = 15;
   const chars = '0123456789abcdef';

   for (let i = 0; i < idLength; i++) {
         id += chars[Math.floor(Math.random() * chars.length)];
   }

   return id;
}

export function generateUUID() {
   let uuid = '';
   const chars = '0123456789abcdef';

   for (let i = 0; i < 36; i++) {
      if (i === 8 || i === 13 || i === 18 || i === 23) {
         uuid += '-';
      } else if (i === 14) {
         uuid += '4';
      } else {
         uuid += chars[Math.floor(Math.random() * chars.length)];
      }
   }

   return uuid;
}


export const selectValues = (values, checkedValues) => {
   let new_data
   if (values.every(value => checkedValues.includes(value))) {
      new_data = checkedValues.filter(checkedValue => !values.includes(checkedValue))
   } else {
      new_data = checkedValues.concat(values.filter(value => !checkedValues.includes(value)))
   }
   return new_data
}

export const onlyNumbersAndPoint = (value) => {
   return value.replace(/[^0-9.]/g, '');
}

export const onlyNumbers = (value) => {
   return value.replace(/[^0-9]/g, '');
}

export const calculateEstimateTimeForOrder = (branch, startDate = new Date()) => {
   const estimatedDays = branch.default_estimated_days;
   const schedule = branch.schedule;

   const hasWorkingDays = schedule.some(day => day.work_day);
   if (!hasWorkingDays) return Math.floor(startDate.getTime() / 1000);

   const date = new Date(startDate); // создаём копию, не мутируем оригинал
   let count = 0;

   // Считаем только рабочие дни
   while (count < estimatedDays) {
      date.setDate(date.getDate() + 1);

      const currentWeekDay = date.getDay() || 7; // воскресенье = 0 → 7
      const dayInfo = schedule.find(day => day.week_day === currentWeekDay);

      if (dayInfo?.work_day) {
         count++;
      }
   }

   // Проверка: не попали ли мы во внерабочее время
   const weekDay = date.getDay() || 7;
   const dayInfo = schedule.find(day => day.week_day === weekDay && day.work_day);

   if (dayInfo) {
      const [startHour, startMin] = dayInfo.start_time.split(":").map(Number);
      const [endHour, endMin] = dayInfo.end_time.split(":").map(Number);

      const workStart = new Date(date);
      workStart.setHours(startHour, startMin, 0, 0);

      const workEnd = new Date(date);
      workEnd.setHours(endHour, endMin, 0, 0);

      if (date < workStart) {
         date.setHours(startHour, startMin, 0, 0);
      } else if (date > workEnd) {
         // если уже после рабочего дня, двигаемся к следующему рабочему дню
         do {
            date.setDate(date.getDate() + 1);
            const nextWeekDay = date.getDay() || 7;
            const nextDayInfo = schedule.find(d => d.week_day === nextWeekDay && d.work_day);

            if (nextDayInfo) {
               const [nextStartHour, nextStartMin] = nextDayInfo.start_time.split(":").map(Number);
               date.setHours(nextStartHour, nextStartMin, 0, 0);
               break;
            }
         } while (true);
      }
   }

   return Math.floor(date.getTime() / 1000);
};


//// const startDate = new Date(2025, 5, 4, 8, 30);
//
// const branch = {
//    default_estimated_days: 4,
//    schedule: [
//       { week_day: 1, start_time: "09:00", end_time: "18:00", work_day: true },
//       { week_day: 2, start_time: "09:00", end_time: "18:00", work_day: true },
//       { week_day: 3, start_time: "09:00", end_time: "18:00", work_day: true },
//       { week_day: 4, start_time: "09:00", end_time: "18:00", work_day: true },
//       { week_day: 5, start_time: "09:00", end_time: "18:00", work_day: true },
//       { week_day: 6, start_time: "10:00", end_time: "18:00", work_day: true },
//       { week_day: 7, start_time: "09:00", end_time: "18:00", work_day: false }
//    ]
// };
//
// const formatter = new Intl.DateTimeFormat('ru-RU', {
//    year: 'numeric',
//    month: '2-digit',
//    day: '2-digit',
//    hour: '2-digit',
//    minute: '2-digit'
// });
//
// const estimateTime = calculateEstimateTimeForOrder(branch, startDate);
// const date = new Date(estimateTime * 1000);
//
// console.log(formatter.format(startDate));
// console.log(formatter.format(date))

